(function($, Drupal) {
  /**
   * @type {{attach: Drupal.behaviors.resizeText.attach}}
   */
  Drupal.behaviors.resizeText = {
    attach : function(context, settings) {
      // settings
      let baseFontSize = 16;
      let maxFontSize = 25;
      let minFontSize = 16;

      // elements
      let $TRIncrease = $("#text_resize_increase");
      let $TRDecrease = $("#text_resize_decrease");
      let $allTRbuttons = $(".text-resize-changer");
      let $html = $("body");
      let currentFontSize = localStorage.getItem("currentFontSize") === null ? baseFontSize :
        localStorage.getItem("currentFontSize");

      // init
      $html.css("font-size", currentFontSize + "px");

      // events handlers ----------
      $TRIncrease.on('click enterKey touchend', function() {
        currentFontSize = currentFontSize * 1.2;
        currentFontSize = currentFontSize > maxFontSize ? maxFontSize : currentFontSize;
        $html.css("font-size", currentFontSize + "px");
        localStorage.setItem("currentFontSize", currentFontSize);
      });

      $TRDecrease.on('click enterKey touchend', function() {
        currentFontSize = currentFontSize / 1.2;
        currentFontSize = currentFontSize < minFontSize ? minFontSize : currentFontSize;
        $html.css("font-size", currentFontSize + "px");
        localStorage.setItem("currentFontSize", currentFontSize);
      });

      $allTRbuttons.keyup(function(e) {
        if (e.keyCode === 13) {
          $(this).trigger("enterKey");
        }
      });
      // ----------------

    }
  };
})(jQuery, Drupal);
